// ヘッダーバー: ロゴ / 総合シグナル / 最新データ日付 / API設定トグル（children）。
import { SIGNAL_LABEL } from "../utils/labels.js";

function overallSignal(counts) {
  if (!counts) return "ok";
  if (counts.danger > 0) return "danger";
  if (counts.warn > 0) return "warn";
  return "ok";
}

function Header({ counts, latestDate, lastUpdated, children }) {
  const overall = overallSignal(counts);

  return (
    <header className="app-header">
      <div className="brand">
        <span className="brand-dot" />
        PortWatch
      </div>

      <div className="header-right">
        <div
          className={`badge signal-${overall}`}
          role="status"
          aria-live="polite"
        >
          <span className="dot" />
          総合: {SIGNAL_LABEL[overall]}
        </div>

        <div className="header-meta">
          <span className="label">最新データ</span>
          <span className="value">{latestDate ?? "—"}</span>
        </div>

        <div className="header-meta">
          <span className="label">更新</span>
          <span className="value">
            {lastUpdated ? lastUpdated.slice(0, 10) : "—"}
          </span>
        </div>

        {children}
      </div>
    </header>
  );
}

export default Header;
